import {tv} from 'tailwind-variants'
import styles from './styles.module.css'

export const cinematicImageVariants = tv({
  slots: {
    outerContainer: 'col-span-full col-start-1 row-start-1 grid',
    container:
      'col-start-1 col-end-auto row-start-1 row-end-auto h-full w-screen min-w-full',
    imageWrapper: '',
    imageSlot:
      'w-full rounded-none [&_img]:h-full [&_img]:w-full [&_img]:min-w-full [&_img]:object-cover',
  },
  variants: {
    layer: {
      background: {
        container: 'z-[3]',
        imageSlot: styles.backgroundImage,
      },
      fade: {
        container:
          'opacity-1 z-[3] hidden transition-opacity duration-500 group-hover:opacity-0 sm:block',
      },
      mask: {
        container: 'z-[2] hidden sm:block',
      },
      mobile: {
        container: 'block sm:hidden',
      },
    },
    variant: {
      overlay: {
        container: 'max-h-dvh min-h-dvh overflow-hidden object-center',
        imageWrapper:
          'aspect-h-16 aspect-w-9 h-full sm:aspect-h-5 sm:aspect-w-4 xl:aspect-h-9 xl:aspect-w-16',
      },
      stacked: {
        outerContainer: 'row-start-2 h-full',
        imageWrapper:
          'aspect-h-5 aspect-w-4 h-fit sm:aspect-h-1 sm:aspect-w-2 lg:aspect-h-1 lg:aspect-w-2',
        imageSlot: '[&_img]:object-top',
      },
      // TODO: Remove when all old cinematic heros are updated
      old: {
        imageWrapper:
          'aspect-h-16 aspect-w-9 h-full sm:aspect-h-5 sm:aspect-w-4 lg:aspect-h-2 lg:aspect-w-3 3xl:aspect-h-9 3xl:aspect-w-16',
      },
    },
    desktopAspectRatio: {
      '21:9': {
        imageWrapper: 'xl:aspect-w-21 xl:aspect-h-9',
      },
      '16:5': {
        imageWrapper: 'xl:aspect-h-5 xl:aspect-w-16',
      },
    },
  },
  compoundVariants: [
    // TODO: Remove when all old cinematic heros are updated
    {
      variant: ['old', 'overlay'],
      class: {
        imageSlot: 'h-full [&_img]:h-full [&_img]:min-h-[900px]',
        imageWrapper: 'h-full',
      },
    },
  ],
})
